import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import TicketSchemaContainer from '../../containers/Ticket/TicketSchema';
import FormSelect from "../form/FormSelect";

const styles = () => {
	return {
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		},
	};
};

class TicketSchemaPicker extends PureComponent {
	componentDidMount  () {
		if (_.isEmpty(this.props.ticketSchemas)) {
			this.props.searchTicketSchemas();
		}
	}

	render () {
		const {ticketSchemas, classes} = this.props;

		if (_.isEmpty(ticketSchemas)) {
			return (<div className={classes.fetching}>Fetching schemas...</div>);
		}

		const options = _.sortBy(ticketSchemas, 'displayName').map(ticketSchema => {
			const { ticketSchemaId, displayName } = ticketSchema;
			return {
				value : ticketSchemaId,
				display : displayName,
			};
		});

		return (
			<FormSelect
				{...this.props}
				options={options}
			/>
		);
	}
}

TicketSchemaPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,

	searchTicketSchemas: PropTypes.func,
	ticketSchemas : PropTypes.array,
};

TicketSchemaPicker.defaultProps =  {
	label : 'Ticket Schema',
};

export default _.flow([
	withStyles(styles),
	TicketSchemaContainer,
])(TicketSchemaPicker);